import { NumberValidering } from '../../Shared/Scripts/Utilities/Validering';
import { StudiepoengHeltAr, StudiepoengEttSemester } from '../Veileder';
import VeilederHounDto from '../Models/VeilederHounDto';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';

export const CStudiepoengValidering: NumberValidering<VeilederHounDto> = {
    min: 1,
    max: StudiepoengHeltAr,
    minFeil: 'obsmeldingAntallStudiepoengMin',
    maxFeil: 'obsmeldingAntallStudiepoengHeltid',
    variablesMap: new Map<string, string>([['${min}', '0'], ['${max}', StudiepoengHeltAr.toString()]]),
};

export const CxStudiepoengValidering: NumberValidering<VeilederHounDto> = {
    min: 1,
    max: StudiepoengEttSemester,
    minFeil: 'obsmeldingAntallStudiepoengMin',
    maxFeil: 'obsmeldingAntallStudiepoengDeltid',
    variablesMap: new Map<string, string>([['${min}', '0'], ['${max}', StudiepoengEttSemester.toString()]]),
};

export const fSkolepengerValidering = (maxVerdi: number, locale: string): NumberValidering<VeilederHounDto> => {
    return {
        min: 0,
        max: maxVerdi,
        minFeil: 'obsMeldingSkolepengerMin',
        maxFeil: 'obsMeldingSkolepengerMax',
        variablesMap: new Map<string, string>([['${belop}', tilPengerFormat(maxVerdi, locale)]]),
    };
};
